import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {UserService} from '../../services/user.service';
import {ActivatedRoute} from '@angular/router';


@Component({templateUrl: './confirm.html', styleUrls: ['./confirm.scss']})
export class ConfirmComponent {
  private code;
  public message;
  public constructor(
      private router: Router, private user: UserService,
      private activeRoute: ActivatedRoute) {
    this.activeRoute.queryParams
        .subscribe(params => {
          if (params.code) {
            this.code = params.code;
            this.user.confirmAccount(params.code).subscribe(
                res => {  this.message = "The Account has been confirmed, you can close this window"}, err => { 
                  if(err.error && err.error.errors && err.error.errors.length > 0)
                    this.message = err.error.errors[0].message;
                  else
                    this.message = "Please provide a valid confimation code."
                });
          } else {
            this.message = "Please provide a confimation code.";
          }
        });   
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/confirm/confirm.ts